import React, { useState, useEffect } from 'react';
import TextField from '@material-ui/core/TextField';
import Modal from 'components/Tvendo/Common/ModalBase';
import { wsFindBy } from 'services/WService';
import { Autocomplete } from '@material-ui/lab';

export default function ModalDetail(props) {
  const Detail = props.model;
  const { id, config } = props;
  const [dataChanging, setDataChanging] = useState([]);
  const [route, setRoutes] = useState([]);
  const [bureaus, setBureaus] = useState([]);

  function handleChange(field, value) {
    setDataChanging(prev => ({ ...prev, [field]: value }));
  }
  
  async function listBureau() {
    let response = await wsFindBy('base/bureau', {base_zone_id: config.vehicle?.base_zone_id});
    if (response.success) setBureaus(response.data);
  }
  
  async function listRoute() {
    let response = await wsFindBy('base/route', { state: 'A', base_zone_id: config.vehicle?.base_zone_id });
    if (response.success) setRoutes(response.data);
  }

  useEffect(() => {
    if (!!config.vehicle?.base_zone_id) {
      listRoute();
      listBureau();
    }
  }, [config.vehicle?.base_zone_id]);

  return (
    <Modal
      title="Nueva ruta para configuración"
      model={Detail}
      setOpen={props.setOpen}
      showNotify={props.showNotify}
      reload={props.reload}
      entity="prog/program-config-detail"
      state
      dataForce={{
        prog_configuration_distribution_id: id,
        base_bureau_id: dataChanging.base_bureau_id,
        base_route_id: dataChanging.base_route_id,
      }}
    >
      <Autocomplete
        disableClearable
        options={bureaus}
        getOptionLabel={(item) => `${item.description}`}
        renderInput={(params) => (
          <TextField {...params} label="Mesa" margin="normal" required />
        )}
        onChange={(e, item) => {handleChange('base_bureau_id', item?.id);}}
        value={bureaus.find(b => b.id === dataChanging.base_bureau_id) || null}
      />
      <Autocomplete
        disableClearable
        options={route}
        getOptionLabel={(item) => `${item.description} (Código: ${item.code})`}
        renderInput={(params) => (
          <TextField {...params} label="Rutas" margin="normal" required />
        )}
        onChange={(e, item) => {handleChange('base_route_id', item?.id);}}
        value={route.find(rt => rt.id === dataChanging.base_route_id) || null}
      />
    </Modal>
  );
}
